<template>
  <div class="app-container">
    <list ref="list"></list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/sys/initialize/initcashbanks/list'

export default {
  name: "initcashbanks",
  mixins: [curdMixins],
  components: { list },
  data() {
    return {}
  },
  mounted() {
    this.reload();
  },
  methods: {}
};
</script>